import React from 'react';
import { Section, SelectField, ColorField } from './FormFields';

const DesignTab = ({ content, updateDesign }) => {
  return (
    <div className="space-y-6">
      <Section title="Typography" description="Customize fonts and text styles.">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <SelectField 
            label="Heading Font" 
            value={content.design?.typography?.headingFont || 'Inter'} 
            options={['Inter', 'Nunito', 'Outfit', 'Poppins']} 
            onChange={(v) => updateDesign('typography', 'headingFont', v)} 
          />
          <SelectField 
            label="Heading Weight" 
            value={content.design?.typography?.headingWeight || '600'} 
            options={[
              { value: '500', label: 'Medium (500)' }, 
              { value: '600', label: 'Semibold (600)' }, 
              { value: '700', label: 'Bold (700)' }
            ]} 
            onChange={(v) => updateDesign('typography', 'headingWeight', v)} 
          />
          <SelectField 
            label="Body Font" 
            value={content.design?.typography?.bodyFont || 'Inter'} 
            options={['Inter', 'Nunito', 'Outfit', 'Noto Sans']} 
            onChange={(v) => updateDesign('typography', 'bodyFont', v)} 
          />
        </div>
      </Section>

      <Section title="Colors" description="Customize your brand colors.">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          <ColorField 
            label="Primary" 
            value={content.design?.colors?.primary || '#1e293b'} 
            onChange={(v) => updateDesign('colors', 'primary', v)} 
          />
          <ColorField 
            label="Primary Light" 
            value={content.design?.colors?.primaryLight || '#334155'} 
            onChange={(v) => updateDesign('colors', 'primaryLight', v)} 
          />
          <ColorField 
            label="Secondary" 
            value={content.design?.colors?.secondary || '#64748b'} 
            onChange={(v) => updateDesign('colors', 'secondary', v)} 
          />
        </div>
      </Section>

      <Section title="Buttons" description="Customize button appearance.">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <ColorField 
            label="Primary Button BG" 
            value={content.design?.buttons?.primaryBg || '#1e293b'} 
            onChange={(v) => updateDesign('buttons', 'primaryBg', v)} 
          />
          <ColorField 
            label="Primary Button Text" 
            value={content.design?.buttons?.primaryText || '#ffffff'} 
            onChange={(v) => updateDesign('buttons', 'primaryText', v)} 
          />
        </div>
      </Section>
    </div>
  );
};

export default DesignTab;
